/* unplugin-vue-components disabled */import script from "./SelectInitiatorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectInitiatorModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectInitiatorModal.vue?vue&type=style&index=0&id=36805753&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36805753"]])

export default __exports__